import { LocalStorage, LOCAL_STORAGE_KEYS } from 'utils';

export function clearExpressDesignerStorage(): void {
  LocalStorage.removeItem(LOCAL_STORAGE_KEYS.EXPRESS_DESIGNER);
}
